<template lang="html">
  <footer class="app-footer w-full) max-w-(--ui-container) lg:m-auto">
    <div
      class="app-footer__logo -mb-px flex items-center justify-center border border-default p-2"
    >
      <a href="/">
        <UIcon :name="brandIcons.logoLargeDark" class="h-14 w-auto" />
      </a>
    </div>

    <div class="app-footer__nav grid grid-cols-[1fr] border-t-0 lg:grid-cols-[2fr_1fr_1fr]">
      <div class="flex flex-col gap-4 border border-default px-4 py-10 text-muted max-lg:-mb-px">
        <div>Московский офис</div>
        <div>123112, Москва, Пресненская наб., 12 (башня "Федерация", Восток)</div>
        <div>+7 (495) 123-45-67</div>
      </div>

      <div class="border border-default px-4 py-10 max-lg:-mb-px lg:-ml-px">
        <UNavigationMenu orientation="vertical" :items="middleMenu" variant="link" />
      </div>

      <div class="flex flex-col gap-1 border border-default px-4 py-10 lg:-ml-px">
        <UNavigationMenu orientation="vertical" :items="rightMenu" variant="link" />
        <div class="px-2.5 text-sm text-muted">
          @{{ currentYear }}
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import type { NavigationMenuItem } from '@nuxt/ui'

import { brandIcons } from '~/app/theme/brand'

const rightMenu = computed<NavigationMenuItem[]>(() => [
  {
    label: 'Публичная оферта',
    to: '/offer',
  },
  {
    label: 'Политика конфиденциальности',
    to: '/privacy',
  },
  {
    label: 'Политика возвратов',
    to: '/returns',
  },
])
const middleMenu = computed<NavigationMenuItem[]>(() => [
  {
    label: 'Главная',
    to: '/',
  },
  {
    label: 'Каталог',
    to: '/catalog',
  },
  {
    label: 'О бренде',
    to: '/about',
  },
  {
    label: 'FAQ',
    to: '/faq',
  },
  {
    label: 'Новости',
    to: '/news',
  },
  {
    label: 'Блог',
    to: '/blog',
  },
])

const currentYear = computed(() => new Date().getFullYear())
</script>
